enum StatusFileEnum {
	Active = 0,
	Proccessing = 1,
	Lock = 2,
	InProgress = 3
}
export default StatusFileEnum
